// extracted by mini-css-extract-plugin
export default {"actions":"eb6c7f4a15b2449d","action":"e6340468ffa3a0cb"};